export const locale = {
    lang: 'es',
    data: {
        NO_RESULTS: 'No se encontraron resultados'
    }
}